import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, map, Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Product } from '../../requests/models/product';
import { StoreData } from '../models/store-data';
import { getAmlScoreConfig } from '../../../assets/aml-config/aml-score-config';
@Injectable({
  providedIn: 'root',
})
export class ProductService {
  private readonly queryEndpoint = `${environment.api}/prodotto-query/prodotto`;
  private readonly commandEndpoint = `${environment.api}/prodotto-command/prodotto`;

  constructor(private http: HttpClient) {}

  private _analisiCreditoProduct = new BehaviorSubject(
    new StoreData<Product>()
  );

  analisiCreditoProduct$ = this._analisiCreditoProduct.asObservable().pipe(
    filter((prodData) => prodData.state === 'completed'),
    map((prodData) => prodData.data)
  );

  get analisiCreditoProduct() {
    return this._analisiCreditoProduct.getValue().data;
  }

  set analisiCreditoProduct(prod: Product | undefined) {
    this._analisiCreditoProduct.next(
      this._analisiCreditoProduct.value.update('completed', prod)
    );
  }

  list(idPratica: string): Observable<Product[]> {
    return this.http.get<Product[]>(
      `${this.queryEndpoint}/pratica/${idPratica}`
    );
  }

  add(newProduct: Product) {
    return this.http.post(this.commandEndpoint, newProduct);
  }

  edit(updatedProduct: Partial<Product>, productId: string) {
    return this.http.patch(
      `${this.commandEndpoint}/${productId}`,
      updatedProduct
    );
  }

  delete(productId: string) {
    return this.http.delete(`${this.commandEndpoint}/${productId}`);
  }

  getAnalisiCreditoProduct(idPratica: string) {
    return this.list(idPratica).pipe(
      map((products) => {
        if (!products[0]) {
          this.analisiCreditoProduct = undefined;
          throw 'Nessun prodotto trovato per la pratica in esame';
        }
        return products[0];
      }),
      tap((prod) => {
        this.analisiCreditoProduct = prod;
        this._analisiCreditoProduct.next(
          this._analisiCreditoProduct.value.update('completed', prod)
        );
      })
    );
  }

  resetProduct() {
    this._analisiCreditoProduct.next(
      this._analisiCreditoProduct.value.update('init')
    );
  }

  getAmlScore() {
    return of(getAmlScoreConfig());
  }

  getComuni(): Observable<Record<string, 'ALTO' | 'BASSO'>> {
    return this.http.get<Record<string, 'ALTO' | 'BASSO'>>(
      `assets/aml-config/comuni.json`
    );
  }
}
